
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


const columnHeaders = [
    {
        label: "Math Confidence",
        width: "15%",
    },
    {
        label: "Camera Station",
        width: "15%",
    },
    {
        label: "Event Location",
        width: "15%",
    },
    {
        label: "Tags",
        width: "15%",
    },
    {
        label: "Event Time/Data",
        width: "20%",
    }
]


export default function EventListColumnHeader() {

    return (
        <Stack direction="row" spacing={0} sx={{ alignItems: 'center', backgroundColor: 'shadow.light' }}>
            <Stack direction="row" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flex: '1 0 15%', pl: 2}}>
                <Radio sx={{ fontSize: '16px', fontWeight: 'light', color: 'text.primary', ml: '8px' }} />
                <Typography sx={{ color: 'primary.main', fontWeight: 'bold', textAlign: 'center' }}>All</Typography>
            </Stack>

            {columnHeaders.map( (col, index) =>
               <Stack key={index} direction="row" sx={{ display: 'flex', alignItems: 'center', flex: '1 0 ' + col.width, justifyContent: 'center' }}>
                    <Typography sx={{ color: 'primary.main', fontWeight: 'bold', textAlign: 'center' }}>{col.label}</Typography>
                </Stack>
            )}

        </Stack>
    )

}
